import * as React from 'react';
import Helmet from 'react-helmet';

var SEO = function SEO(_ref) {
  var lang = _ref.lang,
    title = _ref.title,
    titleTemplate = _ref.titleTemplate,
    description = _ref.description,
    canonical = _ref.canonical,
    robots = _ref.robots,
    schema = _ref.schema;
  return /*#__PURE__*/React.createElement(Helmet, {
    htmlAttributes: {
      lang: lang
    },
    titleTemplate: titleTemplate && titleTemplate
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }), /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: robots
  }), canonical && /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: canonical
  }), schema && schema.map(function (json) {
    return /*#__PURE__*/React.createElement("script", {
      key: title,
      type: "application/ld+json"
    }, json);
  }));
};
var SEO$1 = SEO;

export { SEO$1 as default };
//# sourceMappingURL=index.js.map
